module.exports = __webpack_public_path__ + "static/media/kalender.d92d73db.svg";